import { httpClient } from './httpClient';

export interface Tag {
    id: number;
    name: string;
    description?: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export const tagService = {
    getAllTags: async () => {
        try {
            return await httpClient.get<Tag[]>('/api/tags');
        } catch (error) {
            // Return empty array instead of throwing error when no tags are found
            return [];
        }
    },

    getTagById: async (id: number) => {
        return httpClient.get<Tag>(`/api/tags/${id}`);
    },

    createTag: async (name: string, description?: string) => {
        return httpClient.post<Tag>('/api/tags', { name, description });
    },

    updateTag: async (id: number, name: string, description?: string) => {
        return httpClient.put<Tag>(`/api/tags/${id}`, { name, description });
    },

    deleteTag: async (id: number) => {
        return httpClient.delete<Tag>(`/api/tags/${id}`);
    },

    searchTags: async (query: string) => {
        return httpClient.get<Tag[]>(`/api/tags?search=${encodeURIComponent(query)}`);
    }
};
